import { useNuxtApp } from "#imports";
import mock from "../../utils/mockBugsnag.js";
export const useBugsnag = () => {
  try {
    return useNuxtApp().$bugsnag;
  } catch {
    console.error("Bugsnag is not available");
    return mock;
  }
};
